import SKUFieldGroup from './SKUFieldGroup';

export default SKUFieldGroup;
